<template>
  <div class="photo-container swiper-container">
    <div class="photo-title">{{currentIndex +1}} / {{total}}</div>
    <div class="swiper-wrapper"></div>
    <div class="foot">
      <div class="foot-item" v-for="item in buttons" :key="item.handle" @click="handle(item)">
        <template v-if="item.hasTips">
          <span class="tips-left">点击原图照片更清楚</span>
          <span class="tips-right">长按照片可保存到相册</span>
        </template>
        <icon-svg :iconClass="getIcon(item.icon)"></icon-svg>
        <span class="foot-title">{{item.title}}</span>
      </div>
    </div>
    <Modal :show.sync="show" @confirm="confirm">
      <template slot="title">
        <div class="modal-title">可删除照片数量{{userDeleteNum.available}}/{{userDeleteNum.total}}张</div>
      </template>
      <template ref="content">
        <div class="model-form">
          <verify-code :contentWidth="verifyCodeWidth" :identifyCode="identifyCode" @refresh="refreshIdentifyCode"></verify-code>
          <input
            v-model="inputStr"
            type="text"
            class="modal-input"
            placeholder="请输入验证码"
            @focus="focus"
          />
          <span class="modal-error" v-if="!verifidate">验证码输入错误！</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Swiper from "../libs/swiper/swiper";
import API from "@/service/API";
import Session from "../utils/session";
import Modal from "../components/modal";
import verifyCode from "../components/verifyCode";
import "../libs/swiper/swiper.min.css";
import "@/assets/less/viewDetail.less";
import Message from '../components/messageBox'

// import '@/assets/less/foot.less';
export default {
  components: {
    Modal,
    verifyCode
  },
  data() {
    return {
      status: {
        love: false,
        star: false,
        HD: false
      },
      show: false,
      page: 1,
      hasNext: true,
      type: null,
      currentIndex: 0,
      list: [],
      total: 0,
      swiper: null,
      userDeleteNum: {
        total: 5, // 可删除总数
        available: 0 // 剩余可删除数
      },
      identifyCode: "1234", // 随机验证码
      inputStr: "",
      verifidate: true // 验证状态
    };
  },
  computed: {
    buttons: function(){
      let button;
      if(this.list.length > 0 && this.list[this.currentIndex].image_type == "image"){
        button = {
          handle: "HD",
          title: "原图",
          icon: "HD",
          hasTips: true
        }
      } else {
        button = {
          handle: "download",
          title: "下载",
          icon: "download",
        }
      }
      if(Session.get('userId')){
        return [
          {
            handle: "love",
            title: "点赞",
            icon: "love",
          },
          button,
          {
            handle: "collection",
            title: "收藏",
            icon: "star",
          },
          {
            handle: "delete",
            title: "删除",
            icon: "unlovely",
          }
        ]
      } else {
        return [
          button
        ]
      }
    },
    verifyCodeWidth: function() {
      return document.body.clientWidth * 0.6;
    }
  },
  mounted() {
    let that = this;
    let params = this.$route.params;
    let query = this.$route.query;
    let list = params.list;
    if (!list) {
      this.$router.back();
      return;
    }
    this.list = list;
    this.total = params.total;
    this.currentIndex = params.currentIndex;
    this.$data.page = query.page;
    this.$data.type = query.type;
    this.viewPhotoCount(list[that.currentIndex])
    this.swiper = new Swiper(".swiper-container", {
      initialSlide: params.currentIndex,
      zoom: true,
      on: {
        transitionEnd: function() {
          let index = this.activeIndex;
          that.currentIndex = index;
          that.status.love = that.list[index].has_voted;
          that.status.star = that.list[index].has_faved;
          that.status.HD = that.list[index].HD;
          that.viewPhotoCount(that.list[index])
        }
      },
      virtual: {
        slides: list,
        renderSlide: function(slide, index) {
          that.status.love = that.list[index].has_voted;
          that.status.star = that.list[index].has_faved;
          that.status.HD = that.list[index].HD;
          if (index >= that.list.length - 1) {
            that.getList();
          }
          if (slide.image_type == "image" || slide.image_type == "png") {
            return `<div class="swiper-slide">
                <div class="swiper-zoom-container">
                  <img class="photo-img" src="${slide.url}?x-oss-process=style/thumail_0.5" alt="${slide.name}">
                </div>
              </div>`;
          } else {
            return `<div class="swiper-slide">
                <video controls class="photo-img" src="${slide.url}" poster="${slide.thumbnail_url}" />
              </div>`;
          }
        }
      }
    });
    if(window.wx){
      // 禁止分享
      wx.hideMenuItems({
        showAllNonBaseMenuItem: [] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      });
    }
    document.title = this.$route.meta.title;
  },
  methods: {
    getIcon(icon) {
      if (this.status[icon]) {
        return icon + "-active";
      } else {
        return icon;
      }
    },
    handle(item) {
      this[item.handle](item);
    },
    love(item) {
      let currentItem = this.list[this.currentIndex];
      let param = {
        user: Session.get("userId"),
        photo: currentItem.id
      };
      if (this.status.love) {
        API.removeLike(param).then(res => {
          currentItem.has_voted = false;
          this.status.love = false;
        });
      } else {
        API.addLike(param).then(res => {
          currentItem.has_voted = true;
          this.status.love = true;
        });
      }
    },
    HD() {
      let currentIndex = this.swiper.activeIndex;
      let currentItem = this.list[currentIndex];
      if (currentItem.image_type == "video" || currentItem.HD) return;
      let img = new Image();
      let currentImg = document.body.querySelector(
        ".swiper-slide-active .photo-img"
      );
      const url_hd = currentItem.url + '?x-oss-process=style/thumail_hd'
      img.onload = res => {
        currentImg.src = url_hd;
        currentItem.thumbnail_url = url_hd;
        currentItem.HD = true;
        this.status.HD = true;
      };
      img.src = url_hd;
    },
    download(){
      
      let currentIndex = this.swiper.activeIndex;
      let currentItem = this.list[currentIndex];
      if (currentItem.image_type == "image" || currentItem.HD) return;
      API.download({
        url: currentItem.url
      }).then( (res) => {
        console.log(res.url);
        let video = document.createElement('a');
        video.href = res.url;
        video.click()
      })
    },
    collection() {
      let currentItem = this.list[this.currentIndex];
      let param = {
        user: Session.get("userId"),
        photo: currentItem.id
      };
      if (this.status.star) {
        API.removeFavorite(param).then(res => {
          currentItem.has_faved = false;
          this.status.star = false;
        });
      } else {
        API.addFavorite(param).then(res => {
          currentItem.has_faved = true;
          this.status.star = true;
        });
      }
    },
    delete() {
      
      let currentItem = this.list[this.currentIndex];
      let params = {
        photoId: currentItem.id
      };
      API.canDeletePhoto(params).then(res => {
        this.$data.userDeleteNum.total = res.data.hidden_count_max;
        this.$data.userDeleteNum.available = res.data.hidden_count_left;
        if(this.$data.userDeleteNum.available == 0){
          Message({
            type:'error',
            content: '您的删除名额已经用完。'
          })
        }else{
          this.$data.verifidate = true;
          this.$data.show = true;
          this.refreshIdentifyCode();
        }
      });
    },
    refreshIdentifyCode() {
      this.$data.identifyCode = this.getIdentifyCode();
    },
    confirm(value) {
      if (
        this.$data.inputStr.toLowerCase() !==
        this.$data.identifyCode.toLowerCase()
      ) {
        this.$data.verifidate = false;
        this.$data.inputStr = "";
        this.refreshIdentifyCode();
        return false;
      }
      // 确认删除
      let currentItem = this.list[this.currentIndex];
      let param = {
        user: Session.get("userId"),
        photo: currentItem.id
      };
      API.deletePhoto(param).then(res => {
        let currentIndex = this.swiper.activeIndex;
        this.$data.show = false;
        this.$data.list.splice(currentIndex, 1);
        this.swiper.virtual.removeSlide(currentIndex);
        this.swiper.virtual.update();
        this.$data.total--;
        this.$data.inputStr = "";
        Message({
          type:'success',
          content: '删除成功。'
        })
      }, res => {
        this.$data.show = false;
        Message({
          type:'error',
          content: res.msg
        })
        
      });
    },
    getList() {
      let that = this;
      let routeParams = that.$route.params;
      if (!that.$data.hasNext) {
        return false;
      }
      switch (this.$data.type) {
        case "album":
          this.$data.page++;
          let params = {
            album: routeParams.albumId,
            page: that.$data.page
          };
          API.getPhotoList(params).then(res => {
            let { data, hasNext } = res;
            if (res.data.photos) {
              let newList = [];
              res.data.photos.map(item => {
                newList = newList.concat(item.ps);
              });
              that.$data.list = that.$data.list.concat(newList);
              that.swiper.virtual.slides = that.$data.list;
              that.$data.hasNext = hasNext;
            }
          });
          break;
        case "photo":
          this.$data.page++;
          let photoParams = {
            album: Session.get("albums"),
            page: this.$data.page
          };
          API.getList(photoParams).then(res => {
            this.$data.hasNext = res.hasNext;
            this.$data.list = this.$data.list.concat(res.list);
            that.swiper.virtual.slides = that.$data.list;
          });
          break;
      }
    },
    focus() {
      this.$data.verifidate = true;
    },
    getIdentifyCode() {
      let codeArr = [
        "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "a", "b", "c", "d", "e", "f", "g", "h", "j", "k", "l", "m", "n", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y"
      ];
      let identifyCode = "";
      for (let i = 0; i < 4; i++) {
        let randomIndex = parseInt(Math.random() * codeArr.length);
        identifyCode += codeArr[randomIndex];
      }
      return identifyCode;
    },
    viewPhotoCount(item){
      API.viewPhotoCount({id:item.id})
    }
  }
};
</script>
